import { ILookup } from 'src/app/shared/form/lookup.model';

export enum OelCorrectionMethod {
    QuebecModel = 0,
    BriefAndScalaModel = 1,
    OSHA_AltLinear = 2,
    ChileMinisterioDeSalud = 3,
    EqualEnergyPrinciple = 4
}

// QuebecModel (value 0) also represents the AIOH 'Australianised Quebec' adjustment (same math),
// so its user-facing label is 'AIOH / Quebec Adjustment'. Values are unchanged.
export const OelCorrectionMethodLabels: Record<OelCorrectionMethod, string> = {
    [OelCorrectionMethod.QuebecModel]: 'AIOH / Quebec Adjustment',
    [OelCorrectionMethod.BriefAndScalaModel]: 'Brief And Scala Model',
    [OelCorrectionMethod.OSHA_AltLinear]: 'OSHA Alt Linear',
    [OelCorrectionMethod.ChileMinisterioDeSalud]: 'Chile Ministerio De Salud',
    [OelCorrectionMethod.EqualEnergyPrinciple]: 'Equal Energy Principle',
};

export const getOelCorrectionMethodLookup = (): ILookup[] =>
    Object.keys(OelCorrectionMethodLabels)
        .map(Number)
        .map(value => ({ id: value, name: OelCorrectionMethodLabels[value as OelCorrectionMethod] }));

export const getOelCorrectionMethodNames = (): string[] => {
    const names: string[] = [];
    Object.keys(OelCorrectionMethodLabels)
        .map(Number)
        .forEach(value => { names[value] = OelCorrectionMethodLabels[value as OelCorrectionMethod]; });
    return names;
};
